import * as React from 'react';
import {
  BillingInvoiceItem,
  ClosetPlanType,
  InvoiceItemType,
  InvoicePaymentStatus,
  LegacyPaymentStatus,
} from 'types/plansales/billing';
import { NULL_TEXT } from 'constants/common';
import { toMantissaWithThousandComma } from 'modules/utils/number';
import styled from 'styled-components';
import { Link as RouterLink } from 'react-router-dom';
import { getUtcAndKstTime } from 'modules/billing';
import { billingInvoiceItemLabel } from 'constants/plansales/billing';

const isPaidSuccessfully = (paymentStatus: LegacyPaymentStatus) =>
  !(
    paymentStatus === LegacyPaymentStatus.TRIED_YET ||
    paymentStatus === LegacyPaymentStatus.FAIL ||
    paymentStatus === LegacyPaymentStatus.VOID ||
    paymentStatus === LegacyPaymentStatus.CREATED
  );

export const paymentPriceCellRenderer = (
  totalAmount: number,
  paymentStatus: LegacyPaymentStatus,
) => {
  if (!isPaidSuccessfully(paymentStatus)) return NULL_TEXT;
  return toMantissaWithThousandComma(totalAmount, 2);
};

export const paymentDateCellRenderer = (
  paymentDate: string,
  paymentStatus: LegacyPaymentStatus,
) => {
  if (!isPaidSuccessfully(paymentStatus)) return NULL_TEXT;
  return <PaymentDateStyle>{getUtcAndKstTime(paymentDate)}</PaymentDateStyle>;
};

export const paymentInvoiceDateCellRenderer = (
  paymentDate: string,
  paymentStatus: InvoicePaymentStatus,
) => {
  if (
    paymentStatus !== InvoicePaymentStatus.Completed &&
    paymentStatus !== InvoicePaymentStatus.Refunded
  )
    return NULL_TEXT;
  return <PaymentDateStyle>{getUtcAndKstTime(paymentDate)}</PaymentDateStyle>;
};

export const advancedInvSuffix = (invoiceItem: InvoiceItemType, planType: ClosetPlanType) =>
  [InvoiceItemType.FIRST_SUBSCRIPTION, InvoiceItemType.RENEW_SUBSCRIPTION].includes(invoiceItem) &&
  planType === ClosetPlanType.ADVANCED_PLAN_INV
    ? ' INV'
    : '';

export const billingInvoiceItemRenderer = (
  items: BillingInvoiceItem[],
  planType: ClosetPlanType,
) => {
  return items.map(({ invoiceItemType, amount }, index: number) => {
    return (
      <ItemText key={index}>{`${billingInvoiceItemLabel[invoiceItemType]}${advancedInvSuffix(
        invoiceItemType,
        planType,
      )} / ${amount}`}</ItemText>
    );
  });
};

const ItemText = styled.div`
  display: block;
`;

const PaymentDateStyle = styled.span`
  font-size: 13px;
`;

export const PayStatusStyle = styled.span`
  &.emphasized {
    color: red;
    font-weight: 600;
  }
`;

export const RouteText = styled(RouterLink)`
  text-decoration: underline;
  word-break: break-all;
  color: ${props => props.theme.palette.grey[900]};
`;

export const SearchableText = styled.span`
  word-break: break-all;
  &:hover {
    cursor: pointer;
  }
`;
